module.exports = __webpack_public_path__ + "img/04ec816.jpg";